import React from "react"
import { Controller, Scene } from "react-scrollmagic"
import { Tween } from "react-gsap"
import { GatsbyImage } from "gatsby-plugin-image"
import Border from "../../assets/svg/headshots/headshot-border.inline.svg"
import LeftCorner from "../../assets/svg/headshots/headshot-left-corner.inline.svg"
import RightCorner from "../../assets/svg/headshots/headshot-right-corner.inline.svg"

const Headshot = ({ image, altText, height }) => {
  return (
    <div className="headshot-wrapper h-100 position-relative">
      <div className="headshot position-absolute">
        <GatsbyImage className="w-100 h-100" image={image} alt={altText} />
      </div>
      <div className="headshot-background">
        <Controller>
          <Scene reverse={true} duration={height}>
            {progress => (
              <>
                <Border className="w-100 h-100 border" />
                <Tween
                  from={{
                    opacity: 0,
                    transform: "translate3d(-100vw, 0, 0)",
                  }}
                  totalProgress={progress}
                  paused
                >
                  <div className="left-corner w-100 h-100">
                    <LeftCorner />
                  </div>
                </Tween>
                <Tween
                  from={{ opacity: 0, transform: "translate3d(100vw, 0, 0)" }}
                  totalProgress={progress}
                  paused
                >
                  <div className="right-corner w-100 h-100">
                    <RightCorner />
                  </div>
                </Tween>
              </>
            )}
          </Scene>
        </Controller>
      </div>
    </div>
  )
}

export default Headshot
